import { withStyles } from '@material-ui/core';
import { StyledSelect } from '../../../../Dispatch/RouteExecution/Pickups/PickupManagement/components/Select';

const styles = (theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 4,
    marginBottom: 4
  },
  rowLabel: {
    fontSize: theme.textFontSize,
    color: theme.dispatchPanelHeaderColor,
    marginRight: 6
  },
  InputLabelProps: {
    color: theme.iconColor,
    transform: 'translate(14px, 13px) scale(1)'
  },
  selectFilterClass: {
    display: 'flex',
    marginRight: 8,
    minWidth: '80px',
    '&>div': {
      flex: 1,
      width: '100%'
    }
  },
  equipmentType: {
    minWidth: 84,
    margin: '0 8 0 0'
  }
});

const SelectWithLabel = ({
  id,
  classes,
  value,
  errorInfo,
  label = '',
  placeHolder = '',
  ...otherProps
}) => {
  return (
    <div className={classes.container}>
      <div className={classes.rowLabel}>{label}</div>
      <div className={classes.selectFilterClass}>
        <StyledSelect
          id={id}
          label={label}
          textFieldProps={{
            id: id,
            label: placeHolder,
            variant: 'outlined',
            helperText: errorInfo?.noFMECustomer
          }}
          value={value}
          InputLabelProps={{
            classes: {
              root: classes.InputLabelProps
            }
          }}
          menuPosition="fixed"
          error={Boolean(errorInfo?.noFMECustomer)}
          inputClass={classes.equipmentType}
          {...otherProps}
        />
      </div>
    </div>
  );
};

export default withStyles(styles)(SelectWithLabel);
